import { render, staticRenderFns } from "./GuidedModeAttributeStep.vue?vue&type=template&id=9b070ec8"
import script from "./GuidedModeAttributeStep.vue?vue&type=script&lang=ts"
export * from "./GuidedModeAttributeStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports